<template>
  <!-- <div :style="{ direction: settings.locale == 'ar-AR' ? 'rtl' : 'ltr' }"> -->
  <div>
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";
import moment from "moment";
import "moment/locale/fr";
import "moment/locale/ar-tn";

import { mapState } from "vuex";
import english from "@/locales/en-US";
import arabic from "@/locales/ar-AR";
import french from "@/locales/fr-FR";
import swahili from "@/locales/sw-KE";
import { isKenyanSchool } from "@/utilities/countrySpecific";

arabic.localeAntd.locale = "ar-tn";

const locales = {
  "en-US": english,
  "fr-FR": french,
  "ar-AR": arabic,
  "sw-KE": swahili,
};

// moment formats month and day names from its own global locale, so it has to
// follow the UI language for helpers like formatFeeName to read correctly.
const MOMENT_LOCALES = {
  "en-US": "en",
  "fr-FR": "fr",
  "ar-AR": "ar-tn",
  "sw-KE": "en",
};

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: "en-US",
  fallbackLocale: "en-US",
  messages: {
    "en-US": locales["en-US"].messages,
    "fr-FR": locales["fr-FR"].messages,
    "ar-AR": locales["ar-AR"].messages,
    "sw-KE": locales["sw-KE"].messages,
  },
});

export default {
  name: "Localization",
  mounted() {
    this.$i18n.locale = this.settings.locale;
    this.syncMomentLocale();
    this.applyCountryTerminologyOverrides();
    this.updateNProgressText();
  },
  computed: {
    ...mapState(["settings"]),
    locale() {
      return locales[this.settings.locale].localeAntd;
    },
  },
  watch: {
    "settings.locale": function (value) {
      this.$i18n.locale = value;
      this.syncMomentLocale();
      this.applyCountryTerminologyOverrides();
      this.updateNProgressText();
    },
    "settings.activeBuilding": function () {
      this.applyCountryTerminologyOverrides();
      this.updateNProgressText();
    },
  },
  methods: {
    syncMomentLocale() {
      moment.locale(MOMENT_LOCALES[this.settings.locale] || "fr");
    },

    applyCountryTerminologyOverrides() {
      // Keep VueI18n in sync with locale modules (avoids stale keys after HMR).
      this.$i18n.setLocaleMessage("en-US", english.messages);
      this.$i18n.setLocaleMessage("fr-FR", french.messages);
      this.$i18n.setLocaleMessage("ar-AR", arabic.messages);
      this.$i18n.setLocaleMessage("sw-KE", swahili.messages);

      if (this.settings.locale === "en-US" && isKenyanSchool()) {
        this.$i18n.mergeLocaleMessage("en-US", {
          menu: {
            actulite: "Bulletin",
          },
          sms: {
            actualite: "Bulletin",
            actualiteTemplate:
              "A new bulletin has been added on EdParent with the title: {title}.",
          },
          actualite: {
            ajouterActualite: "Add bulletin",
            modifierActualite: "Edit bulletin",
            details: "Bulletin Details",
            aucuneActualite: "No bulletin published",
            commentsEnabled:
              "Comments can be enabled or disabled for each bulletin separately",
            commentsDisabled: "Comments are disabled for all bulletins",
            enableCommentsForThisNews: "Enable Comments for this Bulletin",
            enableCommentsForThisNewsDesc:
              "Allow users to comment on this bulletin",
            actualitesPlural: "Bulletins",
            actualiteLabel: "Bulletin",
            confirmReject: "Are you sure you want to reject this bulletin?",
            newsValidated: "Bulletin approved successfully",
            newsRejected: "Bulletin rejected successfully",
          },
        });
      }
    },
    updateNProgressText() {
      // Update CSS custom property for nprogress loading text
      const loadingText = this.$t("all.loadingText");
      document.documentElement.style.setProperty(
        "--nprogress-loading-text",
        `'${loadingText}'`
      );
    },
  },
};
</script>
